import { useEffect, useState } from 'react';
import { loadAuthToken } from '@/data/utils/axiosConfigInstance';

export const useAuthHydration = () => {
	const [isHydrated, setIsHydrated] = useState(false);

	useEffect(() => {
		// Load auth token from storage
		loadAuthToken();
		// Mark as hydrated after token is loaded
		setIsHydrated(true);
	}, []);

	return isHydrated;
};
